import { createRef } from 'react'
import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import FormDateInput from 'tfs.form-date-input'
import { validateDate } from 'tfs.front-end-utils/dates'

import constants from '../../config/constants'

import {
  v1setDepartureAirport,
  v1setArrivalAirport,
  v1setDepartureAirportSearch,
  v1setArrivalAirportSearch,
  v1setDepartureDate,
  v1setReturnDate,
  v1setSearch,
} from '../../actions/search'
import v1submitSearchQuery from '../../actions/search/v1submitSearchQuery'

import getLabels from '../../utils/getLabels'
import getFormValues from '../../utils/getFormValues'
import { moment, dateFromFrontEndToBackEndFormat } from '../../utils/dates'

import componentCanCrash from '../../utils/components/componentCanCrash'

import AirportsInput from '../AirportsInput'

import Search from '../../components/Search'

const today = new Date().toISOString().split('T')[0]

export const fields = [
  {
    label: getLabels('from'),
    type: 'text',
    name: 'departureAirport',
    component: AirportsInput,
    required: true,
    autocomplete: 'off',
    elementRef: createRef(),
    placeholder: getLabels('departure_airport'),
  },
  {
    label: getLabels('to'),
    type: 'text',
    name: 'arrivalAirport',
    component: AirportsInput,
    required: true,
    autocomplete: 'off',
    elementRef: createRef(),
    placeholder: getLabels('arrival_airport'),
  },
  {
    label: getLabels('departure'),
    name: 'departureDate',
    component: FormDateInput,
    min: today,
    required: true,
    elementRef: createRef(),
    placeholder: getLabels('departure'),
  },
  {
    label: getLabels('return'),
    name: 'returnDate',
    component: FormDateInput,
    min: today,
    elementRef: createRef(),
    placeholder: getLabels('return'),
  },
]

export const mapStateToProps = state => {
  const {
    v1search,
    v1searchQuery: { isFetching },
  } = state
  const prefilledSearchValueKeys = Object.keys(v1search)

  const prefilledFields = fields.map(field => {
    if (!prefilledSearchValueKeys.includes(field.name)) return field

    /**
     * input[type="date"] expects a defaultValue instead of an initialValue.
     */
    if (field.name.includes('Date')) {
      return {
        ...field,
        defaultValue: v1search[field.name],
      }
    }

    return {
      ...field,
      initialValue: v1search[field.name],
    }
  })

  return {
    userCustomTopCode: state.v1user.customTOPCode || state.v1user.topCode,
    isFetching,
    fields: prefilledFields,
  }
}

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      v1submitSearchQuery,
      v1setDepartureAirport,
      v1setArrivalAirport,
      v1setDepartureAirportSearch,
      v1setArrivalAirportSearch,
      v1setDepartureDate,
      v1setReturnDate,
      v1setSearch,
    },
    dispatch
  ),
  onSubmit: event => {
    event.preventDefault()

    const formFields = getFormValues(fields)

    const departureDate = validateDate(
      moment,
      formFields.departureDate,
      constants.frontEndDateFormat
    )
      ? dateFromFrontEndToBackEndFormat(formFields.departureDate)
      : formFields.departureDate

    const returnDate = validateDate(
      moment,
      formFields.returnDate,
      constants.frontEndDateFormat
    )
      ? dateFromFrontEndToBackEndFormat(formFields.returnDate)
      : formFields.returnDate

    const searchValues = {
      departureAirport: formFields.departureAirport,
      arrivalAirport: formFields.arrivalAirport,
      departureDate: departureDate.replace('/-/g', ''),
      returnDate: returnDate.replace('/-/g', ''),
    }

    dispatch(v1setSearch(searchValues))
    dispatch(v1submitSearchQuery(searchValues))
  },
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  componentCanCrash
)(Search)
